/* frontend/src/pages/VehicleForm.js */
import VehicleForm from './VehicleFormWithPlaca';
export default VehicleForm;
